import { gql } from "@apollo/client";

export const UPLOAD_IMAGES = gql`
  mutation ($input: [FileUploadInput]) {
    uploadImages(input: $input) {
      success
      urls
    }
  }
`;

export const UPLOAD_VIDEO = gql`
  mutation ($title: String!, $video: Upload!) {
    uploadVideo(title: $title, video: $video) {
      VideoType {
        id
        title
        videoUrl
      }
      ErrorResponse {
        ErrorCode
        ErrorReason
      }
    }
  }
`;
